<div class="container">
  <h3>Privacy Policy</h3>
  <p>
    Diese Rezeptsammlung verwendet Google Analytics um das Nutzungsverhalten der Besucher dieser Webseite statistisch zu erfassen.
    Zu diesem Zweck verwendet Google Analytics "Cookies" und andere Technologien. In aggregierter Form werden der vermutete
    Standort der Besucher und die aufgerufenen Seiten visualisiert. Die Details zu Google Analytics sind hier festgehalten:
    <a href="https://www.google.com/analytics/terms/us.html">https://www.google.com/analytics/terms/us.html</a>
  </p>

  <p>Kommentare zu den Rezepten, die mir per E-Mail zugesandt werden, poste ich bei Relevanz zu den Rezepten. Wer das nicht
    will darf mich darauf aufmerksam machen und ich werde den Kommentar nat&uuml;rlich wieder entfernen. Wer pers&ouml;nlich 
    identifiziert wird (weil er oder sie zum Beispiel ein Rezept beigesteuert hat) kann selbstverst&auml;ndlich auch 
    entfernt werden.
  </p>

  <p>Richard Eigenmann, Z&uuml;rich, 2025</p>
  <p>E-Mail:
    <a href="mailto:richard.eigenmann@gmail.com">richard.eigenmann&#64;gmail.com</a>
  </p>

</div>
